// extracted by mini-css-extract-plugin
export var askAiIcon = "_pd-9";
export var container = "_pd-0";
export var groupSeparator = "_pd-a";
export var highlight = "_pd-4";
export var resultIcon = "_pd-5";
export var resultItem = "_pd-7";
export var resultSubtitle = "_pd-3";
export var resultTitle = "_pd-2";
export var resultsList = "_pd-1";
export var searchGroup = "_pd-6";
export var selected = "_pd-8";